"use strict";

var _classCallCheck = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodashEs = require("lodash-es");

var _assessment = require("../../assessment");

var _assessment2 = _interopRequireDefault(_assessment);

var _shortlinker = require("../../helpers/shortlinker");

var _AssessmentResult = require("../../values/AssessmentResult");

var _AssessmentResult2 = _interopRequireDefault(_AssessmentResult);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Assessment for checking the keyword matches in the meta description.
 */


var MetaDescriptionKeywordAssessment = /*#__PURE__*/function (_assessment2$default) {
  _inherits(MetaDescriptionKeywordAssessment, _assessment2$default);

  /**
   * Sets the identifier and the config.
   *
   * @param {Object} [config] The configuration to use.
   * @param {number} [config.parameters.recommendedMinimum] The recommended minimum of keyword occurrences in the meta description.
   * @param {number} [config.scores.good] The score to return if there are enough keyword occurrences in the meta description.
   * @param {number} [config.scores.bad] The score to return if there aren't enough keyword occurrences in the meta description.
   * @param {string} [config.url] The URL to the relevant article on Yoast.com.
   *
   * @returns {void}
   */
  function MetaDescriptionKeywordAssessment() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MetaDescriptionKeywordAssessment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetaDescriptionKeywordAssessment).call(this));
    var defaultConfig = {
      parameters: {
        recommendedMinimum: 1
      },
      scores: {
        good: 9,
        ok: 6,
        bad: 3
      },
      urlTitle: (0, _shortlinker.createAnchorOpeningTag)("https://yoa.st/33k"),
      urlCallToAction: (0, _shortlinker.createAnchorOpeningTag)("https://yoa.st/33l")
    };
    _this.identifier = "metaDescriptionKeyword";
    _this._config = (0, _lodashEs.merge)(defaultConfig, config);
    return _this;
  }
  /**
   * Runs the metaDescriptionKeyword researcher and based on this, returns an assessment result with score.
   *
   * @param {Paper}      paper      The paper to use for the assessment.
   * @param {Researcher} researcher The researcher used for calling research.
   * @param {Jed}        i18n       The object used for translations.
   *
   * @returns {AssessmentResult} The assessment result.
   */


  _createClass(MetaDescriptionKeywordAssessment, [{
    key: "getResult",
    value: function getResult(paper, researcher, i18n) {
      this._keyphraseCounts = researcher.getResearch("metaDescriptionKeyword");
      var assessmentResult = new _AssessmentResult2.default();
      var calculatedResult = this.calculateResult(i18n);
      assessmentResult.setScore(calculatedResult.score);
      assessmentResult.setText(calculatedResult.resultText);
      return assessmentResult;
    }
    /**
     * Returns the result object based on the number of keyword matches in the meta description.
     *
     * @param {Jed} i18n The object used for translations.
     *
     * @returns {Object} Result object with score and text.
     */

  }, {
    key: "calculateResult",
    value: function calculateResult(i18n) {
      // GOOD result when the meta description contains a keyphrase or synonym 1 or 2 times.
      if (this._keyphraseCounts === 1 || this._keyphraseCounts === 2) {
        return {
          score: this._config.scores.good,
          resultText: i18n.sprintf(
          /* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag. */
          i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: Keyphrase or synonym appear in the meta description. Well done!"), this._config.urlTitle, "</a>")
        };
      } // BAD if the description contains every keyword term more than twice.


      if (this._keyphraseCounts >= 3) {
        return {
          score: this._config.scores.bad,
          resultText: i18n.sprintf(
          /**
           * Translators:
           * %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag,
           * %3$s expands to the number of sentences containing the keyphrase,
           * %4$s expands to a link on yoast.com, %5$s expands to the anchor end tag.
           */
          i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: The meta description contains the keyphrase %3$s times, " + "which is over the advised maximum of 2 times. %4$sLimit that%5$s!"), this._config.urlTitle, "</a>", this._keyphraseCounts, this._config.urlCallToAction, "</a>")
        };
      } // BAD if the keyphrases is not contained in the meta description.


      return {
        score: this._config.scores.bad,
        resultText: i18n.sprintf(
        /**
         * Translators:
         * %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag.
         * %3$s expands to a link on yoast.com, %4$s expands to the anchor end tag.
         */
        i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: The meta description has been specified, " + "but it does not contain the keyphrase. %3$sFix that%4$s!"), this._config.urlTitle, "</a>", this._config.urlCallToAction, "</a>")
      };
    }
    /**
     * Checks whether the paper has a keyword and a meta description.
     *
     * @param {Paper} paper The paper to use for the assessment.
     *
     * @returns {boolean} True if the paper has a keyword and a meta description.
     */

  }, {
    key: "isApplicable",
    value: function isApplicable(paper) {
      return paper.hasKeyword() && paper.hasDescription();
    }
  }]);

  return MetaDescriptionKeywordAssessment;
}(_assessment2.default);

exports.default = MetaDescriptionKeywordAssessment;